module.exports = __webpack_public_path__ + "media/images/tennis-overhead-2-55d68b29.jpg";